module.exports = __webpack_public_path__ + "img/mai-tai.a7f0a782.jpg";